import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { Content } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/CoverageSection/Body/SelectWorkPlaceModal/Content'
import { useFilters } from 'modules/shift_management/hooks/useFilters'

interface Props {
  onClose: () => void
  showModal: boolean
  setShowCoverageSection: () => void
}
const SelectWorkPlaceModal = observer(({ onClose, showModal, setShowCoverageSection }: Props) => {
  const [, dispatchFilters] = useFilters()
  const [disableSubmit, setDisableSubmit] = React.useState<boolean>(true)
  const [locationField] = React.useState(() => new Field('', 'string'))

  if (!showModal) return null

  const handleSubmit = () => {
    dispatchFilters({
      type: 'SET_LOCATIONS',
      locationIds: [locationField.value],
    })

    setShowCoverageSection()
    onClose()
  }

  return (
    <Modal
      illustration="time-planning"
      title={i18n.t('shift_management.coverage_section.select_workplace.title')}
      description={i18n.t('shift_management.coverage_section.select_workplace.description')}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={disableSubmit} onClick={handleSubmit} submit>
            {i18n.t('shift_management.coverage_section.select_workplace.submit')}
          </Button>
        </>
      }
    >
      <Content locationField={locationField} setDisableSubmit={setDisableSubmit} />
    </Modal>
  )
})

export { SelectWorkPlaceModal }
